import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/firebase/config';

/**
 * 受注ドキュメントID（内部FK）から表示用の受注番号（案件番号）を解決する。
 * - 受注番号 `orderNo`（例 "0001"）を優先し、無ければ `code`、いずれも無ければ null を返す。
 * - 画面に Firestore の生ドキュメントID を出さず、ユーザーには受注番号を表示するために使う。
 * @param orderId 受注ドキュメントID（null/undefined/空文字の場合は解決しない）
 * @returns 受注番号（解決できない場合は null）
 */
export function useOrderNo(orderId: string | null | undefined): string | null {
  const [orderNo, setOrderNo] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    if (!orderId) {
      setOrderNo(null);
      return;
    }
    void (async () => {
      try {
        const snap = await getDoc(doc(db, 'orders', orderId));
        if (!active) return;
        if (!snap.exists()) {
          setOrderNo(null);
          return;
        }
        const data = snap.data();
        setOrderNo((data['orderNo'] as string) ?? (data['code'] as string) ?? null);
      } catch {
        if (active) setOrderNo(null);
      }
    })();
    return () => {
      active = false;
    };
  }, [orderId]);

  return orderNo;
}
